export enum SmsTemplateType {
  ChamadaSeguranca = 1,
  ChamadaFiscal = 2,
  ChamadaControlCenter = 3,
  FinalizarRecebimento = 4,
  Liberacao = 5,
}

export enum TipoLiberacao {
  ColetaPecas = 1,
  ColetaMotor = 2,
  ColetaEmbalagem = 3,
  Descarregar = 4,
}
